module.exports = __webpack_public_path__ + "media/images/talent/img_insurance-50d89cabcff545fb7f411c83368d5314.png";